<!-- eslint-disable max-len -->
<template>
  <div
    id="container-external-api"
    class="container-app-search">
    <h3 class="modal-title"> {{ fieldDetail ? 'EDIT WIDGET': 'ADD WIDGET' }} </h3>
    <b-row>
      <b-col
        md="6">
        <b-form :class="{'error-input' : $v.dataSetup.type.$error}">
          <label> Type </label>
          <b-row class="type-row">
            <b-col
              v-for="(type, key) in listType"
              :key="key"
              md="3"
              @click="setWidgetType(type.id)">
              <div
                :class="dataSetup.type==type.id? 'type-opt-btn active':'type-opt-btn'">
                <div>
                  <img :src="require(`@/assets/icon/canvas/${type.icon}`)">
                  <p>{{ type.text }}</p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-form>
        <b-form :class="{'error-input' : $v.dataSetup.name.$error}">
          <label> Name </label>
          <j-input
            v-model="$v.dataSetup.name.$model"
            :error-required="$v.dataSetup.name.$error"
            placeholder="Enter field name"/>
        </b-form>
        <b-form :class="{'error-input' : $v.dataSetup.description.$error}">
          <label> Description </label>
          <j-textarea
            v-model="$v.dataSetup.description.$model"
            :error-required="$v.dataSetup.description.$error"
            placeholder="Enter widget description"/>
        </b-form>
        <b-form
          v-if="dataSetup.type === 'text'"
          :class="{'error-input' : $v.dataSetup.format_type.$error}">
          <label> Format </label>
          <j-single-select
            v-model="$v.dataSetup.format_type.$model"
            :options="listFormat"
            :placeholder="'Select Format'"
            :error-required="$v.dataSetup.format_type.$error"
            label="text"/>
        </b-form>
        <b-form :class="{'error-input' : $v.dataSetup.grid.$error}">
          <label> Grid </label>
          <j-single-select
            v-model="$v.dataSetup.grid.$model"
            :options="listGrid"
            :disabled="dataSetup.type === 'map' || dataSetup.type === 'table'"
            :placeholder="'Select Grid'"
            :error-required="$v.dataSetup.grid.$error"
            label="text"/>
        </b-form>
      </b-col>
      <b-col md="6">
        <div>
          <b-form
            v-if="dataSetup.type !== 'table'"
            :class="{'error-input' : $v.dataSetup.sourceData.tableGroup.$error}">
            <label> Table Group </label>
            <j-single-select
              v-model="$v.dataSetup.sourceData.tableGroup.$model"
              :options="tableGroupOptions"
              :placeholder="'Select Table Group'"
              :error-required="$v.dataSetup.sourceData.tableGroup.$error"
              value-format="object"
              label="name"/>
          </b-form>
          <b-form
            v-if="dataSetup.type !== 'table'"
            :class="{'error-input' : $v.dataSetup.sourceData.form.$error}">
            <label> Table </label>
            <j-single-select
              v-model="$v.dataSetup.sourceData.form.$model"
              :disabled="!dataSetup.sourceData.tableGroup"
              :options="tableOptions"
              :placeholder="'Select Table'"
              :error-required="$v.dataSetup.sourceData.form.$error"
              value-format="object"
              label="name"/>
          </b-form>
          <b-form
            v-if="isChart"
            :class="{'error-input' : $v.dataSetup.x_axis_field.$error}">
            <label> X Axis Value </label>
            <j-single-select
              v-model="$v.dataSetup.x_axis_field.$model"
              :options="list_field"
              :error-required="$v.dataSetup.x_axis_field.$error"
              label="name"
              placeholder="Select Column"/>
          </b-form>
          <b-form
            v-if="dataSetup.type === 'bar_chart'"
            :class="{'error-input' : $v.dataSetup.x_axis_limit.$error}">
            <label> X Axis Limit </label>
            <j-input
              v-model="$v.dataSetup.x_axis_limit.$model"
              :error-required="$v.dataSetup.x_axis_limit.$error"
              type="number"
              placeholder="Input Limit"/>
          </b-form>
          <b-form
            v-if="isChart"
            :class="{'error-input' : $v.dataSetup.y_axis_field.$error}">
            <label> Y Axis Value </label>
            <j-single-select
              v-model="$v.dataSetup.y_axis_field.$model"
              :options="list_field"
              :error-required="$v.dataSetup.y_axis_field.$error"
              label="name"
              placeholder="Select Column"/>
          </b-form>
          <b-form
            v-if="dataSetup.type=='map'"
            :class="{'error-input' : $v.dataSetup.marker_icon.$error}">
            <label> Pin Icon </label>
            <j-single-select
              v-model="$v.dataSetup.marker_icon.$model"
              :options="listTypeAttachment"
              :error-required="$v.dataSetup.marker_icon.$error"
              label="name"
              placeholder="Select Column"/>
          </b-form>
          <b-form
            v-if="dataSetup.type=='map'"
            :class="{'error-input' : $v.dataSetup.marker_location.$error}">
            <label> Pin Location </label>
            <j-single-select
              v-model="$v.dataSetup.marker_location.$model"
              :options="listTypeMaps"
              :error-required="$v.dataSetup.marker_location.$error"
              label="name"
              placeholder="Select Column"/>
          </b-form>
          <b-form
            v-if="dataSetup.type=='map'"
            :class="{'error-input' : $v.dataSetup.marker_description.$error}">
            <label> Pin Description </label>
            <j-single-select
              v-model="$v.dataSetup.marker_description.$model"
              :options="listTypeText"
              :error-required="$v.dataSetup.marker_description.$error"
              label="name"
              placeholder="Select Column"/>
          </b-form>
          <b-form
            v-if="dataSetup.type=='text' || dataSetup.type=='progress_bar'"
            :class="{'error-input' : $v.dataSetup.selected_value.$error}">
            <label> Selected Value </label>
            <j-single-select
              v-model="$v.dataSetup.selected_value.$model"
              :options="dataSetup.type=='progress_bar' ? listTypeNumber : list_field"
              :error-required="$v.dataSetup.selected_value.$error"
              label="name"
              placeholder="Select Column"/>
          </b-form>
          <b-form-group
            v-if="dataSetup.type=='table'"
            :class="{'error-input' : $v.dataSetup.form_ui.$error}">
            <label> Form UI </label>
            <j-single-select
              v-model="$v.dataSetup.form_ui.$model"
              :load-options="loadOptionsFormUI"
              :is-async="true"
              :cache-option="false"
              :placeholder="'Select Form UI'"
              :error-required="$v.dataSetup.form_ui.$error"
              value-format="object"
              label="name"/>
          </b-form-group>
          <b-form-group
            v-if="dataSetup.type=='table'"
            :class="{'error-input' : $v.dataSetup.default_view.$error}">
            <label> Default View </label>
            <j-single-select
              v-model="$v.dataSetup.default_view.$model"
              :options="listView"
              :error-required="$v.dataSetup.default_view.$error"
              placeholder="Select View"
              value-format="object"
              label="name"/>
          </b-form-group>
          <b-form :class="{'error-input' : $v.dataSetup.timeframe.$error}">
            <label> Timeframe </label>
            <j-single-select
              v-model="$v.dataSetup.timeframe.$model"
              :options="listTimeframe"
              :error-required="$v.dataSetup.timeframe.$error"
              label="name"
              placeholder="Select Timeframe"/>
          </b-form>
          <b-form
            v-if="dataSetup.type=='progress_bar'"
            :class="{'error-input' : $v.dataSetup.color.$error}">
            <j-color-picker
              v-model="dataSetup.color"
              :color="dataSetup.color"
              :error-required="$v.dataSetup.color.$error"
              label="Color"
              picker="chrome"
            />
          </b-form>
        </div>

        <div
          v-if="dataSetup.type !=='table' && dataSetup.type !=='progress_bar'"
          class="config-canvas-container m__t--10">
          <div class="config-canvas-container__title">Sorting</div>
          <b-form :class="{'error-input' : $v.dataSetup.sorting.key.$error}">
            <label> Sort By </label>
            <j-single-select
              v-model="dataSetup.sorting.key"
              :options="variableOptionsClass"
              :placeholder="'Sort by'"
              :error-required="$v.dataSetup.sorting.key.$error"
              value-format="object"
              label="label"/>
          </b-form>
          <b-form :class="{'error-input' : $v.dataSetup.sorting.order.$error}">
            <label> Order By </label>
            <j-single-select
              v-model="dataSetup.sorting.order"
              :options="orderOptions"
              :placeholder="'Order by'"
              :error-required="$v.dataSetup.sorting.order.$error"
              value-format="object"
              label="label"/>
          </b-form>
        </div>

        <div
          v-if="dataSetup.type !=='table' && dataSetup.type !=='progress_bar'"
          class="config-canvas-container">
          <div class="config-canvas-container__title">Filter</div>

          <div class="d-flex">
            <div
              :class="{ 'active': modeFilter === 'variable' }"
              class="config-canvas-container__label m__r--15"
              @click="selectTab('variable')"
            >
              VARIABLE
            </div>
            <div
              :class="{ 'active': modeFilter === 'function' }"
              class="config-canvas-container__label"
              @click="selectTab('function')"
            >
              FUNCTION
            </div>
          </div>

          <div v-if="modeFilter === 'variable'">
            <b-row
              v-for="(data, index) in dataSetup.filter"
              :key="index"
              class="filter-container">
              <b-col cols="11">
                <b-form class="mb-2">
                  <label> Key </label>
                  <j-single-select
                    v-model="data.key"
                    :error-required="false"
                    :options="variableOptionsClass"
                    :placeholder="'Filter by'"
                    value-format="object"
                    class="list-options-variable"
                    label="label"/>
                </b-form>
                <b-form
                  v-if="data.key && data.key.type === 'timestamp'"
                  class="mb-3"
                >
                  <label> Start Date </label>
                  <j-datepicker
                    v-model="data.start_date"
                    :error-required="false"
                    placeholder="Start Date"
                    format="MMM dd, yyyy"/>
                </b-form>
                <b-form
                  v-if="data.key && data.key.type === 'timestamp'"
                  class="mb-3"
                >
                  <label> End Date </label>
                  <j-datepicker
                    v-model="data.end_date"
                    :error-required="false"
                    placeholder="End Date"
                    format="MMM dd, yyyy"/>
                </b-form>
                <b-form
                  v-if="data.key === null || data.key.type !== 'timestamp'"
                  class="mb-3"
                >
                  <label> Value </label>
                  <j-input
                    v-model="data.value"
                    :error-required="false"
                    :placeholder="'Enter value'"/>
                </b-form>
              </b-col>
              <b-col
                cols="1"
                class="d-flex align-items-start justify-content-center mt-2 pl-0 cursor-pointer p__l--1">
                <i
                  class="fa fa-trash"
                  @click="deleteFilter(index)"
                />
              </b-col>
            </b-row>

            <div
              class="config-canvas-container__btn"
              @click="addFilter">
              + Add
            </div>
          </div>

          <div v-if="modeFilter === 'function'">
            <b-row
              v-for="(data, index) in dataSetup.filter_function"
              :key="index"
              class="filter-container w--100">
              <b-col cols="11">
                <b-form class="mb-2">
                  <label> Variable </label>
                  <j-single-select
                    v-model="data.key"
                    :error-required="false"
                    :options="variableOptionsClass"
                    :placeholder="'Filter by'"
                    value-format="object"
                    class="list-options-variable"
                    label="label"/>
                </b-form>
                <b-form class="mb-3">
                  <label> Function </label>
                  <j-single-select
                    v-model="data.value"
                    :error-required="false"
                    :options="listFunction"
                    :placeholder="'Select Function Name'"
                    class="list-options-variable"
                    label="name"/>
                </b-form>
              </b-col>
              <b-col
                cols="1"
                class="d-flex align-items-start justify-content-center mt-2 pl-0 cursor-pointer p__l--1">
                <i
                  class="fa fa-trash"
                  @click="deleteFilterFunction(index)"
                />
              </b-col>
            </b-row>

            <div
              class="config-canvas-container__btn"
              @click="addFilterFunction">
              + Add
            </div>
          </div>

          <b-form
            v-if="dataSetup.type !=='table'"
            :class="{'error-input' : $v.dataSetup.filterOperator.$error}">
            <label> Filter Operator </label>
            <j-single-select
              v-model="dataSetup.filterOperator"
              :options="filterOperatorOptions"
              :placeholder="'Filter Operator'"
              :error-required="$v.dataSetup.filterOperator.$error"
              label="name"/>
          </b-form>
        </div>
      </b-col>
    </b-row>

    <div class="float-right">
      <b-button
        class="btn m__r--5"
        @click="closeModal">
        Close
      </b-button>
      <b-button
        class="btn blue"
        @click="submitForm">
        {{ fieldDetail ? 'Update' : 'Add' }}
      </b-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-eval, no-mixed-operators */
import { required, requiredIf } from 'vuelidate/lib/validators';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { mapActions } from 'vuex';
import jwtDecode from 'jwt-decode';
import jColorPicker from '@/components/color-picker/jColorPicker';

export default {
  components: {
    jColorPicker,
  },
  props: {
    fieldDetail: {
      type: Object,
      default: () => {},
    },
    variableOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dataSetup: {
        type: 'bar_chart',
        name: null,
        description: null,
        format_type: 'text',
        grid: '1x1',
        tablegroup_id: '',
        tablegroup_name: '',
        form_data_id: '',
        form_data_name: '',
        x_axis_field: null,
        x_axis_limit: null,
        y_axis_field: null,
        marker_icon: null,
        marker_location: null,
        marker_description: null,
        selected_value: null,
        group_by: null,
        form_ui: null,
        default_view: null,
        timeframe: null,
        sourceData: {
          tableGroup: null,
          form: null,
          showData: null,
          searchData: null,
          setValue: null,
        },
        sorting: {
          key: null,
          order: null,
        },
        filter: [
          {
            key: null,
            value: null,
            start_date: null,
            end_date: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
          },
        ],
        filterOperator: null,
        color: '#000000',
      },
      listFunction: [],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      listType: [
        { id: 'bar_chart', text: 'Bar Chart', icon: 'barchart.png' },
        { id: 'line_chart', text: 'Line Chart', icon: 'linechart.png' },
        { id: 'pie_chart', text: 'Pie Chart', icon: 'piechart.png' },
        { id: 'text', text: 'Text', icon: 'text.png' },
        { id: 'table', text: 'Table', icon: 'table.png' },
        { id: 'map', text: 'Map', icon: 'map.png' },
        // { id: 'progress_bar', text: 'Progress Bar', icon: 'progress_bar.png' },
      ],
      listFormat: [
        { id: 'text', text: 'Text' },
        { id: 'currency', text: 'Currency' },
        { id: 'number', text: 'Number' },
      ],
      listGrid: [
        { id: '1x1', text: '1 x 1' },
        { id: '1x2', text: '1 x 2' },
        { id: '1x3', text: '1 x 3' },
      ],
      listView: [
        { id: 'table_view', name: 'Table View' },
      ],
      listTimeframe: [],
      list_field: [],
      variableOptionsClass: [],
      filterOperatorOptions: [
        {
          id: 'and',
          name: 'AND',
        },
        {
          id: 'or',
          name: 'OR',
        },
      ],
      conditionOptions: [
        {
          id: 'is',
          name: 'IS',
        },
      ],
      timestampOptions: [
        {
          id: 'between',
          name: 'BETWEEN',
        },
      ],
      orderOptions: [
        {
          id: 'asc',
          label: 'Ascending',
          text: 'Ascending',
        },
        {
          id: 'desc',
          label: 'Descending',
          text: 'Descending',
        },
      ],
      modeFilter: 'variable',
      tableGroupOptions: [],
      tableOptions: [],
      finishSetDataTableGroup: false,
    };
  },
  computed: {
    isChart() {
      const chartArr = ['bar_chart', 'line_chart', 'pie_chart'];
      return chartArr.includes(this.dataSetup.type);
    },
    listTypeAttachment() {
      return this.list_field.filter(field => field.type === '[]attachment');
    },
    listTypeMaps() {
      return this.list_field.filter(field => field.type === 'maps');
    },
    listTypeText() {
      return this.list_field.filter(field => field.type === 'text');
    },
    listTypeNumber() {
      return this.list_field.filter(field => field.type === 'number');
    },
  },
  watch: {
    // eslint-disable-next-line
    'dataSetup.sourceData.tableGroup': function (val) {
      if (val) {
        this.dataSetup.tablegroup_id = val.id;
        this.dataSetup.tablegroup_name = val.name;
        const reqTable = {
          tablegroup_id: val.id,
          search: '',
        };
        this.getListTableByGroupV2(reqTable).then((res) => {
          if (this.finishSetDataTableGroup) {
            this.dataSetup.sourceData.form = null;
            this.list_field = [];
            this.variableOptionsClass = [];
            this.dataSetup.x_axis_field = null;
            this.dataSetup.x_axis_limit = null;
            this.dataSetup.y_axis_field = null;
            this.dataSetup.filter = [{
              key: null,
              value: null,
              start_date: null,
              end_date: null,
            }];
            this.dataSetup.filter_function = [{
              key: null,
              value: null,
            }];
            this.dataSetup.sorting = {
              key: null,
              order: null,
            };
          }
          if (!res.error) this.tableOptions = res.data || [];
          setTimeout(() => { this.$v.dataSetup.$reset(); }, 10);
        });
      }
    },

    // eslint-disable-next-line
    'dataSetup.sourceData.form': function(data) {
      // const listColumns = Object.keys(data.columns);
      const listColumnsVal = Object.values(data.columns);

      this.dataSetup.form_data_name = data.name;
      this.dataSetup.form_data_id = data.id;
      this.list_field = listColumnsVal.map((e) => {
        e.id = e.name;
        e.text = e.name;
        e.label = e.name;
        return e;
      });

      listColumnsVal.forEach((column) => {
        if (column.type !== '[]attachment') {
          if (column.type === 'person') {
            this.variableOptionsClass.push({
              id: `${column.name}.company_user_id`,
              label: `${column.name}.company_user_id`,
              text: `${column.name}.company_user_id`,
              name: column.name,
              type: column.type,
            });
            this.variableOptionsClass.push({
              id: `${column.name}.name`,
              label: `${column.name}.name`,
              text: `${column.name}.name`,
              name: column.name,
              type: column.type,
            });
            this.variableOptionsClass.push({
              id: `${column.name}.email`,
              label: `${column.name}.email`,
              text: `${column.name}.email`,
              name: column.name,
              type: column.type,
            });
          } else if (column.type === 'object') {
            this.variableOptionsClass.push({
              id: `${column.name}.id`,
              label: `${column.name}.id`,
              text: `${column.name}.id`,
              name: column.name,
              type: column.type,
            });
            this.variableOptionsClass.push({
              id: `${column.name}.name`,
              label: `${column.name}.name`,
              text: `${column.name}.name`,
              name: column.name,
              type: column.type,
            });
          } else if (column.type === 'timer') {
            this.variableOptionsClass.push({
              id: `${column.name}.state`,
              label: `${column.name}.state`,
              text: `${column.name}.state`,
              name: column.name,
              type: column.type,
            });
            this.variableOptionsClass.push({
              id: `${column.name}.duration`,
              label: `${column.name}.duration`,
              text: `${column.name}.duration`,
              name: column.name,
              type: column.type,
            });
          } else if (column.type === 'tags') {
            this.variableOptionsClass.push({
              id: `${column.name}.name`,
              label: `${column.name}.name`,
              text: `${column.name}.name`,
              name: column.name,
              type: column.type,
            });
            this.variableOptionsClass.push({
              id: `${column.name}.background`,
              label: `${column.name}.background`,
              text: `${column.name}.background`,
              name: column.name,
              type: column.type,
            });
            this.variableOptionsClass.push({
              id: `${column.name}.font_color`,
              label: `${column.name}.font_color`,
              text: `${column.name}.font_color`,
              name: column.name,
              type: column.type,
            });
          } else {
            this.variableOptionsClass.push({
              id: column.name,
              label: column.name,
              text: column.name,
              name: column.name,
              type: column.type,
            });
          }
        }
      });

      if (this.fieldDetail && this.fieldDetail.sort && !this.finishSetDataTableGroup) {
        const keySort = Object.keys(this.fieldDetail.sort[0]);
        const valueSort = Object.values(this.fieldDetail.sort[0]);

        this.dataSetup.sorting = {
          key: { id: keySort[0] },
          order: valueSort[0] === 1 ? { id: 'asc' } : { id: 'desc' },
        };
      }

      if (this.fieldDetail && this.fieldDetail.filter && !this.finishSetDataTableGroup) {
        const keyFilter = Object.keys(this.fieldDetail.filter);
        const valueFilter = Object.values(this.fieldDetail.filter);
        if (keyFilter.length > 0) {
          this.dataSetup.filter = [];
          keyFilter.forEach((e, index) => {
            const findType = this.variableOptionsClass.find(f => f.id === e);
            this.dataSetup.filter.push({
              key: findType,
              value: findType.type !== 'timestamp' ? valueFilter[index] : null,
              start_date: findType.type === 'timestamp' ? this.convertTimestamp(valueFilter[index].start) : null,
              end_date: findType.type === 'timestamp' ? this.convertTimestamp(valueFilter[index].end) : null,
            });
          });
        }
      }

      if (this.fieldDetail && this.fieldDetail.filter_function && !this.finishSetDataTableGroup) {
        const keyFilter = Object.keys(this.fieldDetail.filter_function);
        const valueFilter = Object.values(this.fieldDetail.filter_function);
        if (keyFilter.length > 0) {
          this.dataSetup.filter_function = [];
          keyFilter.forEach((e, index) => {
            this.dataSetup.filter_function.push({
              key: { id: e },
              value: valueFilter[index],
            });
          });
        }
      }
    },

    // eslint-disable-next-line
    'dataSetup.key': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.dataSetup.key =
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line
    'dataSetup.type': function (val){
      if (val === 'map' || val === 'table') {
        this.dataSetup.grid = '1x3';
      } else {
        this.dataSetup.grid = '1x1';
      }
    },

    // eslint-disable-next-line
    'dataSetup.form_ui': function (val){
      this.dataSetup.form_data_id = val.form_data_id;
      this.dataSetup.form_data_name = val.form_data_name;
    },

  },
  created() {
    this.getTimeframe();
    this.getListFunction();
    this.getListGroupTable();

    if (this.fieldDetail) {
      // SETUP PARAMS FOR DATA SOURCE
      const params = {
        form_data_id: this.fieldDetail.form_data_id,
        form_data_name: this.fieldDetail.form_data_name,
        x_axis_field: this.fieldDetail.x_axis_field,
        x_axis_limit: this.fieldDetail.x_axis_limit,
        y_axis_field: this.fieldDetail.y_axis_field,
        marker_icon: this.fieldDetail.marker_icon,
        marker_location: this.fieldDetail.marker_location,
        marker_description: this.fieldDetail.marker_description,
        selected_value: this.fieldDetail.selected_value,
        form_ui: this.fieldDetail.form_ui,
        default_view: this.fieldDetail.default_view,
        group_by: this.fieldDetail.group_by,
      };

      this.getFormFirst(this.fieldDetail.form_data_id, params);

      // SETUP STATIC FIELD
      this.dataSetup = {
        type: this.fieldDetail.type,
        name: this.fieldDetail.name,
        description: this.fieldDetail.description,
        format_type: this.fieldDetail.format_type ? this.fieldDetail.format_type : 'text',
        grid: this.fieldDetail.grid,
        tablegroup_id: this.fieldDetail.tablegroup_id,
        tablegroup_name: this.fieldDetail.tablegroup_name,
        form_data_id: this.fieldDetail.form_data_id,
        form_data_name: this.fieldDetail.form_data_name,
        x_axis_field: this.fieldDetail.x_axis_field,
        x_axis_limit: this.fieldDetail.x_axis_limit,
        y_axis_field: this.fieldDetail.y_axis_field,
        marker_icon: this.fieldDetail.marker_icon,
        marker_location: this.fieldDetail.marker_location,
        marker_description: this.fieldDetail.marker_description,
        selected_value: this.fieldDetail.selected_value,
        timeframe: this.fieldDetail.timeframe,
        default_view: { id: this.fieldDetail.default_view },
        group_by: this.fieldDetail.group_by,
        form_ui: {
          id: this.fieldDetail.form_ui_id,
          name: this.fieldDetail.form_ui_name,
          label: this.fieldDetail.form_ui_name,
        },
        sourceData: {
          tableGroup: this.fieldDetail.tablegroup_id ? { id: this.fieldDetail.tablegroup_id } : null,
          form: this.fieldDetail.form_data_id ? { id: this.fieldDetail.form_data_id } : null,
          showData: null,
          searchData: null,
          setValue: null,
        },
        sorting: {
          key: null,
          order: null,
        },
        filter: [
          {
            key: null,
            value: null,
            start_date: null,
            end_date: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
          },
        ],
        filterOperator: this.fieldDetail.filter_operator || null,
        color: this.fieldDetail.config_progress_bar && this.fieldDetail.config_progress_bar.color ?
          this.fieldDetail.config_progress_bar.color : '#000000',
      };

      setTimeout(() => {
        this.dataSetup.grid = this.fieldDetail.grid;
      }, 100);
    } else {
      this.dataSetup = {
        type: 'bar_chart',
        name: null,
        description: null,
        format_type: 'text',
        grid: '1x1',
        tablegroup_id: '',
        tablegroup_name: '',
        form_data_id: '',
        form_data_name: '',
        x_axis_field: null,
        x_axis_limit: null,
        y_axis_field: null,
        marker_icon: null,
        marker_location: null,
        marker_description: null,
        selected_value: null,
        form_ui: null,
        default_view: null,
        group_by: null,
        timeframe: null,
        sourceData: {
          tableGroup: null,
          form: null,
          showData: null,
          searchData: null,
          setValue: null,
        },
        sorting: {
          key: null,
          order: null,
        },
        filter: [
          {
            key: null,
            value: null,
            start_date: null,
            end_date: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
          },
        ],
        filterOperator: null,
        color: '#000000',
      };

      this.$v.dataSetup.$reset();
    }
  },
  methods: {
    ...mapActions('jStoreAutomation', ['getDetailAutomation']),
    ...mapActions('jStoreForm', ['getListDataGroupByCompanyId', 'getListTableByGroupV2', 'findFormData']),

    getListFunction() {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      dataFilter['trigger.type'] = 'function';
      const param = {
        limit: 1000000,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((res) => {
        this.listFunction = res.data.data.map(e => ({
          id: e.trigger.function ? e.trigger.function.name : '',
          name: e.trigger.function ? e.trigger.function.name : '',
        }));
      });
    },
    selectTab(data) {
      this.modeFilter = data;
    },
    convertTimestamp(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
        return `${years}-${mounth}-${dates}`;
      }
      return null;
    },
    addFilter() {
      this.dataSetup.filter.push({
        key: null,
        value: null,
        start_date: null,
        end_date: null,
      });
    },
    deleteFilter(index) {
      this.dataSetup.filter.splice(index, 1);
    },
    addFilterFunction() {
      this.dataSetup.filter_function.push({
        key: null,
        value: null,
      });
    },
    deleteFilterFunction(index) {
      this.dataSetup.filter_function.splice(index, 1);
    },
    getTimeframe() {
      this.listTimeframe = [
        { id: '7 days ago', name: '7 days ago' },
        { id: '30 days ago', name: '30 days ago' },
        { id: '365 days ago', name: '365 days ago' },
        { id: 'This Day', name: 'This Day' },
        { id: 'This Week', name: 'This Week' },
        { id: 'This Month', name: 'This Month' },
        { id: 'This Year', name: 'This Year' },
        { id: '3 years ago', name: '3 years ago' },
        { id: '5 years ago', name: '5 years ago' },
        { id: 'All Time', name: 'All Time' },
      ];
    },
    setWidgetType(type) {
      this.dataSetup.type = type;
    },
    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        const params = {
          type: this.dataSetup.type,
          name: this.dataSetup.name,
          description: this.dataSetup.description,
          format_type: this.dataSetup.type === 'text' ? this.dataSetup.format_type : '',
          grid: this.dataSetup.grid,
          tablegroup_id: this.dataSetup.tablegroup_id,
          tablegroup_name: this.dataSetup.tablegroup_name,
          form_data_id: this.dataSetup.form_data_id,
          form_data_name: this.dataSetup.form_data_name,
          x_axis_field: this.dataSetup.x_axis_field,
          x_axis_limit: this.dataSetup.type === 'bar_chart' ? Number(this.dataSetup.x_axis_limit) : null,
          y_axis_field: this.dataSetup.y_axis_field,
          marker_icon: this.dataSetup.marker_icon,
          marker_location: this.dataSetup.marker_location,
          marker_description: this.dataSetup.marker_description,
          selected_value: this.dataSetup.selected_value,
          form_ui_id: this.dataSetup.form_ui ? this.dataSetup.form_ui.id : null,
          form_ui_name: this.dataSetup.form_ui ? this.dataSetup.form_ui.name : null,
          default_view: this.dataSetup.default_view ? this.dataSetup.default_view.id : null,
          group_by: this.dataSetup.group_by,
          timeframe: this.dataSetup.timeframe,
          sort: [],
          filter: {},
          filter_function: {},
          filter_operator: this.dataSetup.filterOperator,
          config_progress_bar: {
            display_type: 'percentage',
            color: this.dataSetup.color,
          },
        };

        if (this.dataSetup.type !== 'table' && this.dataSetup.type !== 'progress_bar') {
          params.sort.push({
            [this.dataSetup.sorting.key.id]: this.dataSetup.sorting.order.id === 'asc' ? 1 : -1,
          });
        }

        this.dataSetup.filter.forEach((e) => {
          if (e.key) {
            if (e.key.type === 'timestamp') {
              const startDate = e.start_date ? new Date(Date.parse(`${this.$moment(e.start_date).format('YYYY-MM-DD')} 00:00:00`)).getTime() : '';
              const endDate = e.end_date ? new Date(Date.parse(`${this.$moment(e.end_date).format('YYYY-MM-DD')} 23:59:59`)).getTime() : '';
              params.filter[e.key.id] = {
                start: startDate,
                end: endDate,
              };
            } else {
              params.filter[e.key.id] = e.value;
            }
          }
        });

        this.dataSetup.filter_function.forEach((e) => {
          if (e.key) {
            params.filter_function[e.key.id] = e.value;
          }
        });

        if (this.fieldDetail) {
          this.$emit('submit-mode', 'edit', params);
        } else {
          this.$emit('submit-mode', 'add', params);
        }
        this.$emit('close-modal');
      }
    },
    closeModal() {
      this.dataSetup = {
        name: null,
        placeholder: null,
        timeframe: '',
        description: '',
        format_type: 'text',
        grid: '1x1',
        tablegroup_id: '',
        tablegroup_name: '',
        form_data_id: '',
        form_data_name: '',
        x_axis_field: '',
        x_axis_limit: null,
        y_axis_field: '',
        marker_icon: '',
        marker_location: '',
        marker_description: '',
        group_by: '',
        selected_value: null,
        form_ui: null,
        default_view: null,
        type: { id: 'text' },
        variable: null,
        isMandatory: false,
        isDisable: false,
        key: null,
        locationType: 1,
        options: [''],
        acceptedFileType: [],
        isUseCamera: false,
        sourceData: {
          tableGroup: null,
          form: null,
          showData: null,
          searchData: null,
          setValue: null,
        },
        sorting: {
          key: null,
          order: null,
        },
        filter: [
          {
            key: null,
            value: null,
            start_date: null,
            end_date: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
          },
        ],
        filterOperator: null,
        color: '#000000',
      };

      this.$v.dataSetup.$reset();
      this.$emit('close-modal');
    },
    deleteOptions(index) {
      this.dataSetup.options.splice(index, 1);
    },
    async getFormFirst(keyword, params) {
      const req = {
        form_data_id: keyword,
      };
      this.findFormData(req).then((res) => {
        this.dataSetup.sourceData.form = res.data;
        this.dataSetup.x_axis_field = params.x_axis_field;
        this.dataSetup.x_axis_limit = params.x_axis_limit;
        this.dataSetup.y_axis_field = params.y_axis_field;
        this.dataSetup.marker_icon = params.marker_icon ? params.marker_icon : null;
        this.dataSetup.marker_location = params.marker_location;
        this.dataSetup.marker_description = params.marker_description ? params.marker_description : null;
        this.dataSetup.selected_value = params.selected_value;
        this.dataSetup.group_by = params.group_by;
        this.dataSetup.sourceData.form.label = res.data.name;

        if (this.tableGroupOptions.length > 0) {
          const findTableGroup = this.tableGroupOptions.find(f => f.id === this.fieldDetail.tablegroup_id);
          this.dataSetup.sourceData.tableGroup = findTableGroup || null;

          if (!findTableGroup && this.dataSetup.sourceData.form) {
            if (this.dataSetup.sourceData.form.tablegroup_id) {
              const findTableGroupExist = this.tableGroupOptions.find(f => f.id === this.dataSetup.sourceData.form.tablegroup_id);
              this.dataSetup.sourceData.tableGroup = findTableGroupExist || null;
            } else {
              const findTableGroupLegacy = this.tableGroupOptions.find(f => f.id === 'legacy');
              this.dataSetup.sourceData.tableGroup = findTableGroupLegacy;
            }
          } else if (!findTableGroup && !this.dataSetup.sourceData.form) {
            const findTableGroupLegacy = this.tableGroupOptions.find(f => f.id === 'legacy');
            this.dataSetup.sourceData.tableGroup = findTableGroupLegacy;
          }
        }
      });
    },
    loadOptionsForm({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const dataFilter = {
            name: searchQuery,
            company_id: this.session.user.company_id,
          };
          const reqData = {
            limit: 50,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          this.$store.dispatch('jStoreAutomation/getListForm', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
    loadOptionsFormUI({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const dataFilter = {
            name: searchQuery,
            company_id: this.session.user.company_id,
          };
          const reqData = {
            limit: 100,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          this.$store.dispatch('jStoreFormUi/actionGetFormUiListAsync', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },
    getListGroupTable() {
      this.getListDataGroupByCompanyId().then((res) => {
        if (!res.error) {
          this.tableGroupOptions = res.data || [];

          if (this.fieldDetail) {
            const findTableGroup = res.data.find(f => f.id === this.fieldDetail.tablegroup_id);
            this.dataSetup.sourceData.tableGroup = findTableGroup || null;

            if (!findTableGroup && this.dataSetup.sourceData.form) {
              if (this.dataSetup.sourceData.form.tablegroup_id) {
                const findTableGroupExist = res.data.find(f => f.id === this.dataSetup.sourceData.form.tablegroup_id);
                this.dataSetup.sourceData.tableGroup = findTableGroupExist || null;
              } else {
                const findTableGroupLegacy = res.data.find(f => f.id === 'legacy');
                this.dataSetup.sourceData.tableGroup = findTableGroupLegacy;
              }
            } else if (!findTableGroup && !this.dataSetup.sourceData.form) {
              const findTableGroupLegacy = res.data.find(f => f.id === 'legacy');
              this.dataSetup.sourceData.tableGroup = findTableGroupLegacy;
            }

            setTimeout(() => {
              this.finishSetDataTableGroup = true;
            }, 1000);
          }
        }
      });
    },
  },
  validations() {
    return {
      dataSetup: {
        type: {
          required,
        },
        name: {
          required,
        },
        description: {

        },
        format_type: {
          required: requiredIf(() => this.dataSetup.type === 'text'),
        },
        grid: {
          required,
        },
        x_axis_field: {
          required: requiredIf(() => this.dataSetup.type === 'bar_chart' ||
                  this.dataSetup.type === 'line_chart' ||
                  this.dataSetup.type === 'pie_chart'),
        },
        x_axis_limit: {
          required: requiredIf(() => this.dataSetup.type === 'bar_chart'),
        },
        y_axis_field: {
          required: requiredIf(() => this.dataSetup.type === 'bar_chart' ||
                  this.dataSetup.type === 'line_chart' ||
                  this.dataSetup.type === 'pie_chart'),
        },
        marker_icon: {

        },
        marker_location: {
          required: requiredIf(() => this.dataSetup.type === 'map'),
        },
        marker_description: {

        },
        group_by: {

        },
        selected_value: {
          required: requiredIf(() => this.dataSetup.type === 'text' || this.dataSetup.type === 'progress_bar'),
        },
        form_ui: {
          required: requiredIf(() => this.dataSetup.type === 'table'),
        },
        default_view: {
          required: requiredIf(() => this.dataSetup.type === 'table'),
        },
        timeframe: {
          required,
        },
        sourceData: {
          tableGroup: {},
          form: {},
          showData: {},
          searchData: {},
          setValue: {},
        },
        sorting: {
          key: {
            required: requiredIf(() => this.dataSetup.type !== 'table' && this.dataSetup.type !== 'progress_bar'),
          },
          order: {
            required: requiredIf(() => this.dataSetup.type !== 'table' && this.dataSetup.type !== 'progress_bar'),
          },
        },
        filter: {},
        filter_function: {},
        filterOperator: {},
        color: {},
      },
    };
  },
};
</script>

<style lang="scss" scoped>
  .btn-add-column {
    color: #808285;
    padding: 0;
  }

  .external-ui {
    height: 50px;
    margin: 7px 0 22px;
    padding: 12px 138px 11px 14px;
    border-radius: 8px;
    background-color: #f3f3f3;
    font-family: Poppins-Medium;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #626262;
  }

  .font-blue {
    color: #1a85e4 !important;
  }

  .move {
    cursor: move;
  }

  .list-column-ui {
    background-color: #f9f9f9;
    margin: 8px 0;
    padding: 4px 8px;
  }

  .filter-container {
    margin: 8px 0 8px 3px;
    width: 100%;
    border-radius: 8px;
    background-color: #f9f9f9;
  }

</style>



// WEBPACK FOOTER //
// src/views/canvas/widget/jWidgetForm.vue